import Vue from 'vue'
import store from '../store'

/**
 * Control global ui loading state
 *
 * @param isLoading
 */
Vue.prototype.$loading = (isLoading) => {
  store.dispatch('ui/setLoading', isLoading)
}
